<div #control class="form-field" [class.autofilled]="isAutofilled">
  <div
    class="form-field__control"
    [ngClass]="{
      'is-invalid': isFieldInvalid
    }"
  >
    <label class="form-field__label" [for]="id">
      {{ label }}
      <span *ngIf="requiredLabel">*</span>
    </label>
    <input
      class="form-field__input"
      [id]="id"
      [type]="type"
      [disabled]="disabled"
      [placeholder]="placeholder"
      [attr.aria-describedby]="id + '-error ' + ariaDescribedBy"
      [disabled]="disabled"
      [autocomplete]="autocomplete"
      [placeholder]="placeholder"
      [attr.aria-describedby]="id + '-error ' + ariaDescribedBy"
      [tabIndex]="tabIndex"
      [(ngModel)]="value"
      (input)="onChange($any($event.target).value)"
      (blur)="onTouched()"
      (focus)="onFocus()"
      (focusout)="onFocusout()"
      (ngModelChange)="onChange($event)"
      (animationstart)="onAnimationStart($event)"
    />
    <span class="form-field__actions">
      <button
        *ngIf="value && isClearable && !disabled"
        class="form-field__control-clear"
        aria-labelledby="qa_form-field__actions-clear"
        tabindex="-1"
        (click)="clearInput()"
      >
        <i class="fa fa-circle-xmark form-field__control-clear-icon"></i>
        <app-sr-text fieldId="qa_form-field__actions-clear">
          {{ 'checkout.sr.clear-input' | translate }}
        </app-sr-text>
      </button>
      <button
        *ngIf="value && hasShowHide && !disabled"
        class="form-field__control-eye"
        tabindex="-1"
        (click)="togglePasswordVisible()"
      >
        <i *ngIf="showPassword" class="fa fa-eye-slash form-field__control-clear-icon"></i>
        <i *ngIf="!showPassword" class="fa fa-eye form-field__control-clear-icon"></i>
        <app-sr-text fieldId="qa_form-field__actions-clear">
          {{ showPassword ? ('checkout.sr.eye-hide-input' | translate) : ('checkout.sr.eye-show-input' | translate) }}
        </app-sr-text>
      </button>
    </span>
  </div>
</div>
<div *ngIf="isFieldInvalid" class="form-field__invalid-text" [id]="id + '-error'">
  <i class="fas fa-triangle-exclamation"></i>
  <span>{{ validationTranslationKey }}</span>
</div>
